var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import Snackbar from '@mui/material/Snackbar';
import { Alert } from '../alert';
import { styled } from '../styled';
import { toastComponentName, getToastUtilityClass, toastClasses } from './toast-classes';
import { useMergedClasses } from '../styles/classes';
import { Slide } from '../transitions';
import { useThemeProps } from '../theme/use-theme-props';
var autoHideDurationDefaults = {
    danger: 8000,
    warning: 8000,
    success: 5000,
    info: 5000,
    default: 5000,
};
var Root = styled(Snackbar, { name: toastComponentName, slot: 'Root' })({});
var DefaultSnackbarTransition = function (props) { return React.createElement(Slide, __assign({}, props, { direction: "left" })); };
export var Toast = React.forwardRef(function (inProps, ref) {
    // this is needed to make testing easier. It allows overrideing the Transition component.
    var props = useThemeProps({
        props: inProps,
        name: 'MuiSnackbar',
    });
    var action = props.action, propAutoHideDuration = props.autoHideDuration, children = props.children, dismissible = props.dismissible, message = props.message, onClose = props.onClose, onDismiss = props.onDismiss, _a = props.severity, severity = _a === void 0 ? 'default' : _a, title = props.title, icon = props.icon, _b = props.AlertProps, AlertProps = _b === void 0 ? {} : _b, _c = props.TransitionComponent, TransitionComponent = _c === void 0 ? DefaultSnackbarTransition : _c, propClasses = props.classes, rootProps = __rest(props, ["action", "autoHideDuration", "children", "dismissible", "message", "onClose", "onDismiss", "severity", "title", "icon", "AlertProps", "TransitionComponent", "classes"]);
    var classes = useMergedClasses(toastClasses, getToastUtilityClass, propClasses);
    // allow null to disable autoHide
    var autoHideDuration = propAutoHideDuration !== null ? propAutoHideDuration || autoHideDurationDefaults[severity] : null;
    return (React.createElement(Root, __assign({ TransitionComponent: TransitionComponent, autoHideDuration: autoHideDuration, onClose: onClose, ref: ref, className: classes.root }, rootProps), children || (React.createElement(Alert, __assign({ elevation: 4, severity: severity, title: title, icon: icon, onClose: onClose ? function (event) { return onClose(event, 'closeClick'); } : undefined, action: action, dismissible: dismissible, onDismiss: onDismiss, variant: "outlined", className: classes.alert }, AlertProps), message))));
});
